
const dev = [
  {
    path: '/notifications',
    name: 'notifications-test',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/notifications.vue').then(Notifications => {
      return Notifications
    }),
  },
]

export {
  dev
}
